/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const RealtimeResourceChange = zod.object({
  version: zod.literal(1),
  resource: zod.string(),
  resourceId: zod.string(),
  change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  occurredAt: zod.iso.datetime({offset: true}),
});

export type RealtimeResourceChange = zod.input<typeof RealtimeResourceChange>;
export type RealtimeResourceChangeOutput = zod.output<typeof RealtimeResourceChange>;
